<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="golfGroupTbody"
      hide-default-footer
      disable-pagination
    >
      <!-- 有効／無効-->
      <template v-slot:[`item.valid_flag`]="{ item }">
        <v-checkbox v-model="item.valid_flag"/>
      </template>
      <!-- 配信日-->
      <template v-slot:[`item.delivery_date_code`]="{ item }">
        <v-select
          class="mr-3"
          :items="item.selectDeliveryDate"
          inputmode="tel"
          item-value="code"
          item-text="code_name"
          :disabled= "item.isDateActive"
          v-model="item.delivery_date_code"
          @input="inputDeliveryDate(item)"
        ></v-select>
      </template>
      <!-- 配信時刻-->
      <template v-slot:[`item.delivery_time`]="{ item }">
        <v-select
          class="mr-3"
          :items="deliveryTimes"
          inputmode="tel"
          item-value="item_value"
          item-text="item_text"
          :disabled= "item.isTimeActive"
          v-model="item.delivery_time"
        ></v-select>
      </template>
      <!-- 配信方法-->
      <template v-slot:[`item.delivery_type`]="{ item }">
        <v-select
          class="mr-3"
          :items="deliveryTypes"
          inputmode="tel"
          item-value="setting_code"
          item-text="setting_name"
          v-model="item.delivery_type"
        ></v-select>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :disabled="btn[1].isActive" color="green darken-4" text @click="onRegist()">登録</v-btn>
    </v-card-actions>
    <ChangeOverlay
      page-name="配信管理"
      @processing="updateDeliveryMaster"
      @cancel="closeChangeOverLay"
      :process-result="process"
      :OverlaySwitch="changeOverlay"
    />
  </div>
</template>

<script>
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { codeListMixin } from '@/mixins/codeList';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
// graghql
import { GET_DELIVERY_MASTER, UPDATE_DELIVERY_MASTER } from '@/constants/delivery_master';
import { GET_SYSTEM_MASTER } from '@/constants/system_master';

export default {
    components: {
        ChangeOverlay
    },
    mixins: [
        authorityMixin,
        codeListMixin
    ],
    data () {
        return {
            desserts: [],
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: '配信種別', value: 'delivery_name', align: 'left', sortable: false },
                { text: '有効／無効', value: 'valid_flag', align: 'left', sortable: false },
                { text: '配信日', value: 'delivery_date_code', align: 'center', sortable: false },
                { text: '配信時刻（時）', value: 'delivery_time', align: 'center', sortable: false },
                { text: '配信方法', value: 'delivery_type', align: 'center', sortable: false }
            ],
            // ボタンの活性・非活性（authorityMixinを使用する場合は必須）
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '登録', isActive: true }
            ],
            // 配信日リスト
            deliveryDates: [],
            // 配信種別リスト
            deliveryTypes: [],
            changeOverlay: false,
            processing: false,
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            addDeliveryType: {
                setting_group: 'cooperation_app',
                setting_key: 'dummy',
                setting_value: 1,
                setting_group_name: '連携アプリケーション',
                setting_name: '優先順',
                setting_code: '00',
                setting_type: 1,
                setting_unit: ''
            },
            deliveryTimes: [
                { item_value: '00:00', item_text: '00:00' },
                { item_value: '01:00', item_text: '01:00' },
                { item_value: '02:00', item_text: '02:00' },
                { item_value: '03:00', item_text: '03:00' },
                { item_value: '04:00', item_text: '04:00' },
                { item_value: '05:00', item_text: '05:00' },
                { item_value: '06:00', item_text: '06:00' },
                { item_value: '07:00', item_text: '07:00' },
                { item_value: '08:00', item_text: '08:00' },
                { item_value: '09:00', item_text: '09:00' },
                { item_value: '10:00', item_text: '10:00' },
                { item_value: '11:00', item_text: '11:00' },
                { item_value: '12:00', item_text: '12:00' },
                { item_value: '13:00', item_text: '13:00' },
                { item_value: '14:00', item_text: '14:00' },
                { item_value: '15:00', item_text: '15:00' },
                { item_value: '16:00', item_text: '16:00' },
                { item_value: '17:00', item_text: '17:00' },
                { item_value: '18:00', item_text: '18:00' },
                { item_value: '19:00', item_text: '19:00' },
                { item_value: '20:00', item_text: '20:00' },
                { item_value: '21:00', item_text: '21:00' },
                { item_value: '22:00', item_text: '22:00' },
                { item_value: '23:00', item_text: '23:00' }
            ],
            vue_id: 'SCR0105'
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit('loading/setIsLoading', true);

            this.admin = await this.getLoginAdmin();
            await this.getAuthorityList();
            // システム設定より有効な配信種別リスト取得
            await this.getDeliveryType();

            // 配信設定マスタ
            this.getDeliveryMaster();
        },
        /** --------------------------------------------
        * 配信設定マスタ取得
        * -------------------------------------------- */
        async getDeliveryMaster () {
            // コードマスタより配信日のリスト取得
            this.deliveryDates = await this.getCodeList('delivery_date');
            try {
                this.$apollo.query({
                    query: GET_DELIVERY_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                    }
                }).then(res => {
                    this.desserts = res.data.GetDeliveryMaster.DeliveryMasterList;
                    for (var i = 0; i < this.desserts.length; i++) {
                        this.desserts[i].valid_flag = Boolean(this.desserts[i].valid_flag);
                        var copy = Array.from(this.deliveryDates);
                        this.desserts[i].selectDeliveryDate = copy;
                        // 予約のお礼配信（会員、非会員）の場合
                        if (this.desserts[i].real_time_flag === 1) {
                            this.desserts[i]['isDateActive'] = true;
                        } else {
                            this.desserts[i]['isDateActive'] = false;
                        }
                        // 配信日が即時の場合、時間を非表示にする
                        if (this.desserts[i].delivery_date_code === '01') {
                            this.desserts[i]['isTimeActive'] = true;
                        } else {
                            this.desserts[i]['isTimeActive'] = false;
                        }
                        // 随時の配信ができないのでセレクトボックスから削除する
                        if (this.desserts[i].real_time_flag === 0) {
                            for (var j = 0; j < this.desserts[i]['selectDeliveryDate'].length; j++) {
                                if (this.desserts[i]['selectDeliveryDate'][j].code === '01') {
                                    this.desserts[i]['selectDeliveryDate'].splice(j, 1);
                                }
                            }
                        }
                    };
                    this.$store.commit('loading/setIsLoading', false);
                });
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** --------------------------------------------
        * 配信種別リスト取得
        * -------------------------------------------- */
        async getDeliveryType () {
            try {
                await this.$apollo.query({
                    query: GET_SYSTEM_MASTER,
                    fetchPolicy: 'no-cache',
                    variables: {
                        settingGroup: 'cooperation_app',
                        settingValue: 1
                    }
                }).then(res => {
                    this.deliveryTypes = res.data.GetSystemMaster.SystemMasterLists;
                    this.deliveryTypes.unshift(this.addDeliveryType);
                });
            } catch (error) {
                this.resultText = error;
                this.$store.commit('loading/setIsLoading', false);
            }
        },
        /** ----------------------------------------------
         * 配信日入力
         * ---------------------------------------------- */
        inputDeliveryDate (item) {
            if (item.delivery_date_code === '01') {
                item.delivery_time = '00:00';
                item.isTimeActive = true;
            } else {
                item.isTimeActive = false;
            }
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.process.result = '';
            this.changeOverlay = false;
        },
        /** --------------------------------------------
        * 登録ボタン処理
        * -------------------------------------------- */
        onRegist () {
            var updateData = [];
            for (var i = 0; i < this.desserts.length; i++) {
                if (this.desserts[i].valid_flag) {
                    this.desserts[i].valid_flag = 1;
                } else {
                    this.desserts[i].valid_flag = 0;
                }
                let updateRec = {
                    delivery_id: this.desserts[i].delivery_id,
                    delivery_date_code: this.desserts[i].delivery_date_code,
                    delivery_time: this.desserts[i].delivery_time,
                    delivery_type: this.desserts[i].delivery_type,
                    valid_flag: this.desserts[i].valid_flag
                };
                updateData.push(updateRec);
            }

            this.updateDeliveryMaster(updateData);
        },
        /** --------------------------------------------
        * 配信設定マスタ更新処理
        * -------------------------------------------- */
        updateDeliveryMaster: function (updateData) {
            this.processing = true;
            // 配信設定マスタ更新
            this.$apollo.mutate({
                mutation: UPDATE_DELIVERY_MASTER,
                variables: {
                    UpdateDeliveryMasterList: updateData
                }
            }).then(res => {
                this.process.result = res.data.UpdateDeliveryMaster.result;
                if (res.data.UpdateDeliveryMaster.result === 0) {
                    this.process.resultText = this.$t('result.error.change');
                    this.changeOverlay = true;
                    this.processing = false;
                } else if (res.data.UpdateDeliveryMaster.result === 1) {
                    this.process.resultText = this.$t('result.success.change');
                    this.changeOverlay = true;
                    this.processing = false;
                }
            }).catch(error => {
                this.error = error;
                this.process.resultText = this.$t('result.error.change');
                this.changeOverlay = true;
                this.processing = false;
            });
        }
    }
};
</script>

<style scoped>
    .v-data-table{
        overflow-y: scroll;
        min-height: 200px;
        max-height: 600px;
    }
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
